import React, { useEffect } from 'react';
import { Box, CircularProgress, Stack } from '@mui/material';
import { useParams } from 'react-router-dom'; // Add this line to fix the missing type definitions
import { usersService } from '../../../../../services';
import { useTranslation } from 'react-i18next';
import { WidgetPrice } from '../../../../../components/widget/WidgetPrice';
import { WidgetAddress } from '../../../../../components/widget/WidgetAddress';
import { palette } from '../../../../../styles/theme';

const INITIAL_POSITION_STATE = {
    totalMeasurementsSum: 0,
    daily: 0
};

export default function PaymentLinkPositionSection ({ setAlert }) {
    const { id } = useParams();
    const { t } = useTranslation();
    // eslint-disable-next-line no-unused-vars
    const [isLoading, setIsLoading] = React.useState(true);
    const [paymentPosition, setPaymentPosition] = React.useState(INITIAL_POSITION_STATE);

    const monthlySum = paymentPosition?.totalMeasurementsSum + paymentPosition?.daily;

    function getPaymentLinksPosition () {
        setIsLoading(true);
        usersService
            .getPaymentLinksPosition(id)
            .then(async client => {
                setPaymentPosition(client);
                setIsLoading(false);
            })
            .catch(() => {
                setAlert({
                    isOpen: true,
                    severity: 'error',
                    title: t('errors.generalTitle'),
                    description: t('errors.generalDescription')
                });
                setIsLoading(false);
            });
    }
    function formatCurrency (value) {
        if (value === null || value === undefined || value === '') {
            return '-';
        }

        const num = Number(value);
        const fixed = num.toFixed(2);
        let [integer, decimal] = fixed.split('.');
        integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return `$${integer},${decimal}`;
    }

    // eslint-disable-next-line
    useEffect(() => getPaymentLinksPosition(id), []);

    return (
        <>
            {isLoading ? (
                <Stack alignItems={'center'}>
                    <CircularProgress size={24} style={{ color: 'primary' }} />
                </Stack>
            ) : (
                <Box
                    display="flex"
                    flexDirection="column"
                    gap="16px"
                    padding="16px"
                    width="100%"
                    maxWidth="600px"
                    margin="auto"
                >
                    <Box display="flex" justifyContent="space-between">
                        <WidgetAddress
                            title={t('paymentLinksPosition.table.columns.daily')}
                            value={<WidgetPrice number={formatCurrency(paymentPosition?.daily)} textAlign="left" width="156px" />}
                            width="48%"
                            valueColor={palette.primary[700]}
                        />
                        <WidgetAddress
                            title={t('paymentLinksPosition.table.columns.totalMeasurementsSum')}
                            value={<WidgetPrice number={formatCurrency(monthlySum)} textAlign="left" width="156px" />}
                            width="48%"
                            valueColor={palette.primary[700]}
                        />
                    </Box>
                </Box>
            )}
        </>
    );
}
